import { render, staticRenderFns } from "./ProjectOrderResults.vue?vue&type=template&id=2cfbb0fe"
import script from "./ProjectOrderResults.vue?vue&type=script&lang=js"
export * from "./ProjectOrderResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports